import React, { ReactNode } from 'react';
import { UserMenu } from '../UserMenu/UserMenu';
import { IAGLogoColourfull } from '@dynamika-shared/ui/icons';

type SiteUserLayoutProps = {
  children: ReactNode;
};

export const SiteUserLayout: React.FC<SiteUserLayoutProps> = ({ children }) => {
  return (
    <div className='flex h-full flex-col text-spanishGray'>
      <div className='flex justify-between pl-8 pr-4 pt-7'>
        <IAGLogoColourfull className='h-[5.5rem] w-[11rem]' />
        <UserMenu
          useAttributes
        />
      </div>
      <div className='grow'>{children}</div>
    </div>
  );
};
